import { SelectHTMLAttributes } from "react";
import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";

type RadioFieldProps<T> = {
  label?: string;
  subLabel?: string;
  horizontal?: boolean;
  hasRequiredLabel?: boolean;
  options: { label: string; value: T }[];
  register?: UseFormRegisterReturn;
  errors?: FieldErrors<any>;
} & SelectHTMLAttributes<HTMLInputElement>;

const RadioField = ({ label, subLabel, horizontal = true, hasRequiredLabel = false, options, register, errors, ...restProps }: RadioFieldProps<string>) => {
  return (
    <div className="m-form-item">
      <div className="m-form-item__header">
        {label && <p className="m-form-item__caption">{label}{hasRequiredLabel && <span className="required">*</span>}</p>}
        {subLabel && <p className="m-form-item__sub-caption">{subLabel}</p>}
      </div>
      <div className="m-form-item__input">
        <div className={`m-form-item__input__container ${horizontal ? 'flex-row' : 'flex-col'}`}>
        {
          options.map((option) => (
            <label key={option.value}>
              <input type="radio" {...register} {...restProps} value={option.value} />
              {option.label}
            </label>
          ))
        }
        </div>
        {(errors && register && errors[register.name]) && <p className="m-form-item__error">{String(errors[register.name]?.message || '入力エラー')}</p>}
      </div>
    </div>
  );
};

export default RadioField;